<template>
	<popupLayout :popupClass="'mb-lg'">
		<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
		<div class="bootbox-body">
			<div class="row form-group">
				<div class="col-md-12">
					<table class="table table-no-more table-bordered table-striped mb-none">
						<thead>
							<tr>
								<th class="text-center" width="15%">房棟</th>
								<th class="text-center" width="10%">樓層</th>
								<th class="text-center" width="10%">打掃點</th>
								<th class="text-center" width="15%">打掃負責寢室</th>
								<th class="text-center" width="25%">設定時間</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(his, key) in hisList" :key="key">
								<td data-title="房棟" class="text-center">{{his.house}}</td>
								<td data-title="樓層" class="text-center">{{his.flood}}</td>
								<td data-title="打掃點" class="text-center">{{his.cleanLocation}}</td>
								<td data-title="打掃負責寢室" class="text-center">{{(his.defStaffBedFloodRoom ? his.defStaffBedFloodRoom : his.defStaffName)}}</td>
								<td data-title="設定時間" class="text-center">{{(his.settingBeginDate? customFormatter(his.settingBeginDate) + "~" : (his.settingDate ? customFormatter(his.settingDate):""))}}{{his.settingEndDate ? customFormatter(his.settingEndDate) : ""}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="row">
				<div class="col-md-offset-4 col-md-4">
					<div class=" col-md-offset-3 col-md-6">
						<a class="btn btn-danger btn-block" @click="closePopup">關閉</a>
					</div>
				</div>
			</div>
		</div>
	</popupLayout>
</template>
<script>
import popupLayout from '@/components/popup/popupLayout';
export default {
	components:{
		popupLayout
	},
	props:['hisList'],
	methods:{
		closePopup() {
			this.$parent.showHisPopupControl(false);
		},
	}
}
</script>
<style scoped>
@media only screen and (max-device-height : 667px){
	.bootbox-body{
		max-height:480px;
		overflow-y:auto;
	}
}
@media only screen and (max-device-height : 736px) {
	.bootbox-body{
		max-height:600px;
		overflow-y:auto;
	}
}
</style>